import React from "react";
import Button from "../../../../Components/FormElements/Button";

const TextAdjuntar = ({ data, loadingClick, action, actionSecundary }: any) => {
  return (
    <>
      <div className="thankyou-page__texts">
        <p className="thankyou-page__title">
          ¡Tu solicitud de emisión fue enviada con éxito!
        </p>

        <p className="thankyou-page__subtitle">
          Podrás ver si tu solicitud ha sido emitida satisfactoriamente en la
          sección <span>"Cotizaciones".</span> Una vez emitida, se enviará la copia de la
          póliza del cliente a tu correo.
        </p>
      </div>
      <div className="thankyou-page__actions">
        <Button
          type="button"
          onClick={() => action(data)}
          className={loadingClick ? "is-loading" : ""}
        >
          Ir a cotizaciones
        </Button>
        <Button
          type="button"
          className="is-secondary"
          onClick={() => actionSecundary()}
        >
          Ir al Inicio
        </Button>
      </div>
    </>
  );
};

export default TextAdjuntar;
